import { render, staticRenderFns } from "./RichMenu.vue?vue&type=template&id=028d98fa"
import script from "./RichMenu.vue?vue&type=script&lang=js"
export * from "./RichMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports